import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    locale: 'en-US',
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
